import { configureStore } from '@reduxjs/toolkit';
import { persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

import { metronic } from '../../redux/utils';
import * as auth from './storeAuth.js';

const store = configureStore({
    reducer: {
        auth: auth.reducer,
        i18n: metronic.i18n.reducer,
        builder: metronic.builder.reducer
    },
    middleware: (getDefaultMiddleware) => {
        const middleware = getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] // Ignore redux-persist actions. See: https://github.com/rt2zz/redux-persist/issues/988
            }
        });

        return middleware;
    }
});

export const persistor = persistStore(store);

export default store;
